import classNames from 'classnames/bind';
import styles from './EbookActivityDetails.module.css';

const cx = classNames.bind(styles);

export interface RankingListProps {
  rank1: string[];
  rank2: string[];
  rank3: string[];
}

export default function RankingList({ rank1, rank2, rank3 }: RankingListProps) {
  const ranks = [rank1, rank2, rank3];

  if (ranks.every((rank) => rank.length === 0)) return null;

  return (
    <ol className={cx('mobile_ranking')}>
      {ranks.map((rank, index) =>
        rank.length > 0 ? (
          <li key={index} className={cx('ranking_item', `rank_${index + 1}`)}>
            <div>{rank.join(', ')}</div>
          </li>
        ) : null
      )}
    </ol>
  );
}
